import(/* webpackMode: "eager" */ "/app/src/app/nearby/page.tsx");
